// Environment configuration
const config = require('clientconfig')
window.endpoint = config.apiBaseUrl || 'https://api-demo.gomedical.io/core'
// window.endpoint = config.apiBaseUrl || 'https://api-demo.gomedical.io/'
window.stripeKey = config.stripeKey || 'pk_test_402xOsRTE3P8aYFew500Fv87'
window.isLive = config.isLive === 'false' || config.isLive === null || config.isLive === undefined ?false:true

// Global Variables
const moment = require('moment');
window.moment = require('moment');
moment.locale("fr");
window.axios = require('axios');

import Vue from 'vue'
import App from './App.vue'
import responsive from 'vue-responsive'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import Default from './components/Default'
import BadCode from './components/BadCode'
import 'vuetify/dist/vuetify.min.css' 
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false
Vue.use(responsive)
Vue.use(Vuetify)
Vue.use(VueRouter)

var router = new VueRouter({
  mode: "history",
  base: "/",
  routes: [
  {
    name: "default",
    path: "/home",
    component: Default
  },
  {
    name: "badCode",
    path: "/bad-code",
    component: BadCode
  },
  {
      path: "/:code",
      component: App
  }
]
});


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
